import React from 'react';
import {
  getImageUri,
  getImageUrl,
  resolveUserDomainMediaBaseUrl,
  type UserDomainMedia,
} from '@wix/communities-blog-client-common';
import { Image } from '@app/external/common/components/image/image';
import { useSelector } from '@app/external/common/components/runtime-context';
import { type NormalizedPost } from '@app/external/common/types';
import classes from './post-page-post-header-image.scss';

type Props = {
  post: NormalizedPost;
};

const PostPagePostHeaderImage: React.FC<Props> = (props) => {
  const image = props.post.heroImage;

  // Sites can serve their own media from the site domain instead of wixstatic
  // (Thunderbolt passes the config via host props; empty unless enabled for the site).
  const userDomainMedia = useSelector(
    (_, host) => (host as { userDomainMedia?: UserDomainMedia }).userDomainMedia,
  );

  const uri = getImageUrl({
    image,
    maxHeight: 980,
    maxWidth: image?.width,
    type: 'fit',
    encoding: 'AVIF',
    baseHostURL: resolveUserDomainMediaBaseUrl(getImageUri(image), userDomainMedia),
  });

  if (!uri) {
    return null;
  }

  // `uri` is a URL string, so Image cannot read the alt text off it.
  return (
    <Image
      image={uri}
      alt={image?.altText || props.post.title}
      className={classes.img}
      displayMode="fit"
    />
  );
};

export default PostPagePostHeaderImage;
